// components
import { ILog } from '@newo/api/gateway';
import Block from '@/modules/ActLogDrawer/components/Runtime/components/Block';
// utils

interface RuntimeProps {
    logs: ILog[];
}

const Runtime = ({ logs }: RuntimeProps) => {
    const callLogs = logs.filter((log) => log.log_type === 'call').toReversed();
    return (
        <div className="flex flex-col gap-4 py-8">
            {callLogs.map((log) => {
                return <Block block={log} key={log.log_id} />;
            })}
        </div>
    );
};

export default Runtime;
